import { notifyMutationError } from '@inquiries/-lib/handleInquiryCompletedError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { InquiryAssignResponse } from 'backend/types'
import { toast } from 'sonner'
import type { UpdateInquiryAssignRequest } from '@/lib/apiClients/inquiries'
import { updateInquiryAssign } from '@/lib/apiClients/inquiries'
import { queryKeys } from '@/lib/queryKeys'

interface UseUpdateInquiryAssignOptions {
  onSuccess?: (data: InquiryAssignResponse) => void
  onError?: (error: Error) => void
}

export function useUpdateInquiryAssign(inquiryId: number, options: UseUpdateInquiryAssignOptions = {}) {
  const { onSuccess, onError } = options
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ inquiryAssignId, ...data }: UpdateInquiryAssignRequest & { inquiryAssignId: number }) => {
      return updateInquiryAssign(inquiryId, inquiryAssignId, data)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.assigns(inquiryId) })
      toast.success('アサインを更新しました')
      onSuccess?.(data)
    },
    onError: (error: Error) => {
      notifyMutationError(error, 'アサインの更新に失敗しました')
      onError?.(error)
    },
  })
}
